import { 
  FETCH_ASSETS_START, 
  FETCH_ASSETS_SUCCESS, 
  FETCH_AVAILABLE_ASSETS_START,
  FETCH_AVAILABLE_ASSETS_SUCCESS,
  FETCH_AVAILABLE_ASSETS_ERROR,
  FETCH_REFERENCE_CURRENCY_ERROR, 
  FETCH_REFERENCE_CURRENCY_START, 
  FETCH_REFERENCE_CURRENCY_SUCCESS,
  FETCH_DEPOSIT_ADDRESS_ERROR,
  FETCH_DEPOSIT_ADDRESS_SUCCESS,
  FETCH_DEPOSIT_ADDRESS_START,
} from './actionTypes'

export const fetchAssets = (payload) => {
  return {
    type: FETCH_ASSETS_START,
    payload,
  }
}
export const getAssetsSuccess = (payload) => {
  return {
    type: FETCH_ASSETS_SUCCESS,
    payload,
  }
}

// actions.js
export const fetchReferenceCurrency = (payload) => ({
  type: FETCH_REFERENCE_CURRENCY_START,
  payload,
})

export const getReferenceCurrencySuccess = (payload) => ({
  type: FETCH_REFERENCE_CURRENCY_SUCCESS,
  payload,
})

export const getReferenceCurrencyError = (error) => ({
  type: FETCH_REFERENCE_CURRENCY_ERROR,
  error,
})
export const getDepositAddressStart = (currency,chain) => ({
  type: FETCH_DEPOSIT_ADDRESS_START,
  payload: { currency, chain },
})

export const getDepositAddressSuccess = (payload) => ({
  type: FETCH_DEPOSIT_ADDRESS_SUCCESS,
  payload,
})

export const getDepositAddressError = (error) => ({
  type: FETCH_DEPOSIT_ADDRESS_ERROR,
  error,
})

// New actions for fetching available assets from root endpoint
export const fetchAvailableAssets = (payload) => ({
  type: FETCH_AVAILABLE_ASSETS_START,
  payload,
})

export const getAvailableAssetsSuccess = (payload) => ({
  type: FETCH_AVAILABLE_ASSETS_SUCCESS,
  payload,
})

export const getAvailableAssetsError = (error) => ({
  type: FETCH_AVAILABLE_ASSETS_ERROR,
  error,
})